const countryDomains: Record<string, string> = {
  sg: 'https://www.foodpanda.sg',
  my: 'https://www.foodpanda.my',
  ph: 'https://www.foodpanda.ph',
  th: 'https://www.foodpanda.co.th',
  tw: 'https://www.foodpanda.tw',
  bd: 'https://www.foodpanda.bd',
  pk: 'https://www.foodpanda.pk',
  hk: 'https://www.foodpanda.hk'
};

/**
 * todo: Only APAC added for now. To add more later or move this to config
 */
export const getCountryAppDomain = (countryCode: string) => {
  return countryDomains[countryCode.toLowerCase()];
};
